export default __webpack_public_path__ + "static/media/BAFL.6e15b098.png";